(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RelationshipTypeDeleteController',RelationshipTypeDeleteController);

    RelationshipTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RelationshipType'];

    function RelationshipTypeDeleteController($uibModalInstance, entity, RelationshipType) {
        var vm = this;
        vm.relationshipType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RelationshipType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
